import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function getAdminCountries() {
  try {
    const path = `${BACKEND_URL}/admin/countries`;

    const res = await authFetch(
      path,
      { method: "GET" },
      { refreshUrlIncludes: "auth/refresh" },
    );

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        countries: [],
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
      };
    }

    if (!res.ok || result?.success !== true) {
      return {
        success: false,
        countries: [],
        ...normalizeApiMessage(result, "Failed to fetch countries."),
      };
    }

    return {
      success: true,
      countries: Array.isArray(result?.data?.countries)
        ? result.data.countries
        : [],
      ...normalizeApiMessage(result, "Countries loaded successfully."),
    };
  } catch (error) {
    return {
      success: false,
      countries: [],
      ...normalizeApiMessage(
        { message: error?.message || "Network error occurred." },
        error?.message || "Network error occurred.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
